var style = document.createElement('style');
style.type = 'text/css';

style.innerHTML = `
@media screen and (max-width: 768px) {
    .UpPromote-customer-referral-signup-form[data-layout="horizontal"] #up-cx-ref-content-container {
        padding-top: 10px !important;
    }
}
@media (width <= 768px) {
    .UpPromote-customer-referral-signup-form[data-layout=horizontal] {
        margin-top: 0 !important;
    }
}
`;

document.head.appendChild(style);

document.addEventListener("DOMContentLoaded", function() {
    const newImageUrl = "https://cdn.uppromote.com/storage/uploads/banner/knoweats-brand/c3d968a2e0f86382d772b265d3a38425_img-mobile.jpg";

    if (window.matchMedia("(max-width: 768px)").matches) {
        const container = document.getElementById('up-cx-ref-image-container');

        if (container) {
            const source = container.querySelector('source');
            const img = container.querySelector('img');

            if (source) {
                source.srcset = newImageUrl;
            }

            if (img) {
                img.src = newImageUrl;
            }
        }
    }
});


